
import React from 'react'
import './header.css'

const Header = () => {
  return (
    <>
    <div className='header responsive'></div>
    </>
  )
}

export default Header
